// PopupInvitePage.jsx
import React from "react";
import PopupWrapper from "./PopupWrapper";
import AffiliateCampaignInvite from "./AffiliateCampaignInvite";

function PopupInvitePage() {
  // Provide an EMPTY campaign object with null values
  const emptyCampaign = {
    campaign_id: null,
    affiliate_user_id: null,
    affiliated_campaign_id: null,
    campaign_name: "",
    description: "",
    commission: "",
    target_url: "",
  };

  return (
    <PopupWrapper onClose={() => window.history.back()}>
      <AffiliateCampaignInvite
        campaign={emptyCampaign}
        onClose={() => window.history.back()}
      />
    </PopupWrapper>
  );
}

export default PopupInvitePage;
